module.exports = __webpack_public_path__ + "static/img/finance1.19d9becc.png";